import { iconRequest, iconAffiliate, iconParameters } from '../defaultValues';

const data = {
    role_540caae04b84492a9ed46b7c529a8856: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconAffiliate,
                    label: 'Aliados',
                    to: '/app/aliados',
                },
            ],
        },
    ],
};
export default data;
